import IVendorConfig from "src/environments/Ivendor-config";

export function connectionMapper(config: IVendorConfig){
  config.brandsOptionsToDisplay = [
    "Lenovo",
    "Acer",
    "ASUS",
    "Dell",
    "HP",
    "Samsung"
  ];

  config.informationWorkerRequiresFingerprintSensor = true;
  config.informationWorkerRequiresPrivacyScreen = true;
  config.informationWorkerRequiresBacklitKeyboard = true;

  config.executiveMobileWorkerRequiresFingerprintSensor = true;
  config.executiveMobileWorkerRequiresPrivacyScreen = true;
  config.executiveMobileWorkerRequiresBacklitKeyboard = true;
  config.executiveMobileWorkerRequiresStylus = true;
}
